import React from "react";
import styled from "styled-components";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faPaperclip} from "@fortawesome/free-solid-svg-icons";
import downloadFile from "../../util/downloadFile";

const Container = styled.div`
    width: 100%;
    height: 45px;
    font-weight: 600;
    text-align: left;
    padding-left: 25px;
    line-height: 45px;
    box-sizing: border-box;
    border-top: 1px solid #e6e6e6;
    border-bottom: 1px solid #e6e6e6;
    margin: 70px 0 -50px 0;
`;

const Icon = styled(FontAwesomeIcon)`
    color: #888;
    padding-left: 55px;
`;
const Download = styled.a`
    cursor: pointer;
`;

const AttachFile = ({files}) => {

    return (
        files && files.map((file)=> (
            <Container key={file.fileId}>
            첨부파일
            <Download
                onClick={()=>downloadFile({url:file.filePath,name:file.fileName})}
            >
                <Icon icon={faPaperclip}/> {file.fileName}
            </Download>
        </Container>))
    );
};

export default AttachFile;
